/**
 * Column labels for different accounting code types
 * Used in statement of account defaults table
 */
export const AccountingCodeLabels = {
	RECOVERY_CODE: 'Recovery Code',
	ACTIVITY_CODE: 'Activity Code',
	GL_ACCOUNT: 'G/L Account',
	ACTIVITY_CODE_AND_GL_ACCOUNT: 'Activity Code & G/L Account',
} as const;

export type AccountingCodeLabel =
	(typeof AccountingCodeLabels)[keyof typeof AccountingCodeLabels];
